import { locationIdFormat, taskIdFormat } from "@redotech/redo-model/ids";
import { TaskStatusSchema } from "@redotech/redo-model/task/task";
import * as z from "zod/v4";

export const listCycleCounts = {
  name: "listCycleCounts" as const,
  input: z.object({
    locationId: locationIdFormat.schema.optional(),
    search: z.string().optional(),
    status: TaskStatusSchema.optional(),
    page: z.number().int().min(0).default(0),
    pageSize: z.number().int().min(1).max(100).default(25),
  }),
  output: z.object({
    totalCount: z.number(),
    cycleCounts: z.array(
      z.object({
        id: taskIdFormat.schema,
        name: z.string().nullable(),
        status: TaskStatusSchema,
        locationId: locationIdFormat.schema.nullable(),
        locationName: z.string().nullable(),
        skuCount: z.number(),
        binCount: z.number(),
        assignedLegacyUserId: z.string().nullable(),
        assignedRole: z.string().nullable(),
        completedBins: z.number(),
        totalBins: z.number(),
        dueAt: z.date().nullable(),
        createdAt: z.date(),
        updatedAt: z.date(),
      }),
    ),
  }),
};
